<template>
  <div :class="$style.sectionCompare">
    <div class="section">
      <div class="container">
        <p class="dingbeauty-sub-title fancy-title">Comparison</p>
        <h2 class="dingbeauty-title is-dotted">方案功能比較</h2>
        <div class="d-lg-none d-flex color-text-3 mb-3" style="font-size: 0.75rem">
          <div class="align-self-center">
            右滑查看完整內容
            <img @click="slideNext" src="@assets/dingbeauty-images/basic-plan/advantage/Icon_arrowR.svg" alt="" />
          </div>
        </div>
        <div class="table-responsive-lg">
          <table class="table table-width">
            <thead class="sectionCompare__thead">
              <tr class="sectionCompare__thead--th">
                <th scope="col" class="align-middle">功能</th>
                <th v-for="(item, index) in headList" scope="col" class="text-center" width="27%" :key="index">
                  <p>{{ item.title }}</p>
                  <p class="item-price">
                    <span class="money font-josefin">{{ item.money }}</span>
                    <span class="count ml-2">{{ item.year }}</span>
                  </p>
                  <span class="round py-2 px-3">{{ item.backPlan }}</span>
                </th>
              </tr>
            </thead>
            <tbody class="sectionCompare__tbody">
              <tr v-for="(item, $index) in list" :key="$index" class="sectionCompare__tbody--td">
                <td>
                  {{ item.title }}
                  <el-popover v-if="item.popover" placement="top" title="" width="288" trigger="hover" :content="item.popover">
                    <el-button slot="reference" class="el-button">
                      <i class="icomoon icon-info"></i>
                    </el-button>
                  </el-popover>
                </td>
                <td class="text-center">
                  <template v-if="typeof item.reserveplan === 'boolean'">
                    <span v-if="item.reserveplan">
                      <i class="icomoon icon-check check"></i>
                    </span>
                  </template>
                  <template v-else>
                    <div v-html="item.reserveplan"></div>
                  </template>
                </td>
                <td class="text-center">
                  <template v-if="typeof item.marketingplan === 'boolean'">
                    <span v-if="item.marketingplan">
                      <i class="icomoon icon-check check"></i>
                    </span>
                  </template>
                  <template v-else>
                    <div v-html="item.marketingplan"></div>
                  </template>
                </td>
                <td class="text-center">
                  <template v-if="typeof item.intermediate === 'boolean'">
                    <span v-if="item.intermediate">
                      <i class="icomoon icon-check check"></i>
                    </span>
                  </template>
                  <template v-else>
                    <div v-html="item.intermediate"></div>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headList: [
        { title: '初階方案', money: '$20,000', year: '/年', backPlan: '或月繳$2,100' },
        { title: '進階方案', money: '$36,000', year: '/年', backPlan: '或月繳$2,100' },
        { title: '客製化方案', money: '依功能制定', year: '', backPlan: '或月繳$2,100' },
      ],

      list: [
        {
          title: '初階方案功能',
          popover: `包含預約管理系統、客戶＆寵物管理、員工管理、排班設定、管理帳號分權、以及預付方案管理、金流串接、分店設定、簡訊通知、優惠券功能、管理帳號30個、免費網域、報表數據、公版官網、官方Line預約`,
          reserveplan: true,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '金流串接',
          popover: false,
          reserveplan: false,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '分店設定',
          popover: false,
          reserveplan: '單店',
          marketingplan: '額外新增單間分店<br>年繳$15,000元/月繳$1,600<br>(含簡訊300封、管理帳號20個)',
          intermediate: '依據需求設定分店數',
        },
        {
          title: '簡訊通知',
          popover: false,
          reserveplan: '100封/月<br>簡訊加值（一次最低加$1,000）',
          marketingplan: '500封/月<br>簡訊加值（一次最低加$1,000）',
          intermediate: '依據需求設定簡訊數',
        },
        {
          title: '優惠券功能',
          popover: false,
          reserveplan: false,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '管理帳號',
          popover: false,
          reserveplan: '10個',
          marketingplan: `30個`,
          intermediate: `不限制`,
        },
        {
          title: '免費網域',
          popover: false,
          reserveplan: true,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '報表數據',
          popover: false,
          reserveplan: true,
          marketingplan: true,
          intermediate: true,
        },
        {
          title: '官網',
          popover: false,
          reserveplan: false,
          marketingplan: '公版網站',
          intermediate: '客製化品牌官網',
        },
        {
          title: '官方Line預約',
          popover: false,
          reserveplan: false,
          marketingplan: true,
          intermediate: true,
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
.sectionCompare {
  $color-primary: #e3c192;
  position: relative;
  background: rgb(246, 240, 232);
  background: linear-gradient(180deg, rgba(246, 240, 232, 1) 0%, rgba(255, 254, 254, 1) 100%);

  @include max-lg {
    margin-top: 55px;
  }
  :global {
    .align-self-center {
      color: #545662;
      font-size: 14px;
      display: flex;

      img {
        margin-left: 4px;
        width: 30px;
      }
    }
    .baseSectionTitle {
      max-width: 100%;
    }

    .sectionCompare {
      &__thead {
        // background: rgba(215, 178, 126, 0.15);
        border: 6px;
        &--th {
          color: $color-text-1;
          font-size: 21px;
          @include max-md {
            font-size: 18px;
          }
          @include max-sm {
            font-size: 15px;
            .item-price {
            margin-bottom: 8px;
          }
          }
          p {
            margin: 0;
          }
          
          .money {
            font-size: 28px;
            font-weight: 700;
            @include max-md {
              font-size: 24px;
            }
            @include max-sm {
              font-size: 21px;
            }
          }
          .count {
            font-size: 16px;
            padding-left: 5px;
            @include max-md {
              font-size: 14px;
            }
            @include max-sm {
              font-size: 12px;
            }
          }
          .round {
            background: #e3c192;
            font-size: 16px;
            width: auto;
            color: #fff;
          }
          th {
            border-top: 0;
            border-bottom: 0;
            padding-top: 30px;
            padding-bottom: 30px;
            background: #f7f0e5;
            font-weight: 400;
          }
        }
      }
      &__tbody {
        &--td {
          td {
            border-top: 0;
            border-bottom: 1px solid $color-line;
            padding-top: 30px;
            padding-bottom: 30px;
            color: $color-text-2;
            background: #fff;
            vertical-align: middle;
            @include max-md {
              font-size: 14px;
            }
            @include max-sm {
              font-size: 12px;
            }
          }
          .check {
            color: $color-primary;
          }
          .el-button {
            border: 0;
            padding: 0;
            color: $color-text-2;
            &:hover {
              background: transparent;
              color: $color-text-2;
            }
          }
        }
      }
      &__mobile {
      }
    }
    .table-width {
      min-width: 900px;
      position: relative;
      td:first-child,
      th:first-child {
        position: sticky;
        left: 0;
        z-index: 3;
      }
    }
    .finger {
      margin-right: 20px;
      animation-name: slideRight;
      animation-duration: 1.5s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      // transform: translateX(0);
      img {
        max-width: 25px;
      }
    }
  }
}
</style>
